import CenteredContentLayout from "@/components/layout/CenteredContentLayout";
import PageLayout from "@/components/layout/PageLayout";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import HyperliquidUserDataListener from "@nitro-ape/shared/features/hyperliquid/api/listeners/user-data-listener";
import { createFileRoute } from "@tanstack/react-router";
import ActivePositionsCard from "./-components/ActivePositionsCard";
import HoldingsCard from "./-components/HoldingsCard";
import PnlTable from "./-components/PnlTable";
import PortfolioSubHeader from "./-components/PortfolioSubHeader";
import TotalAssetValueCard from "./-components/TotalAssetValueCard";
import TradesCard from "./-components/TradesCard";
import TradingActivityCard from "./-components/TradingActivityCard";
import { PortfolioProvider } from "@nitro-ape/shared/providers/portfolio-provider";

export const Route = createFileRoute("/_main/portfolio/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitlePortfolio),
      },
    ],
  }),
  component: PortfolioPage,
});

function PortfolioPage() {
  return (
    <PortfolioProvider>
      <HyperliquidUserDataListener>
        <PageLayout>
          <CenteredContentLayout>
            <PortfolioSubHeader />
            <div className="flex w-full min-w-0 flex-col items-stretch gap-1.5 md:h-full md:max-h-[557px] md:flex-row">
              <div className="flex w-full flex-col gap-1.5 md:w-[40%] md:min-w-[400px] md:max-w-[690px]">
                <TotalAssetValueCard />
                <TradingActivityCard />
              </div>
              <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-1.5 md:h-full">
                <PnlTable />
                <div className="flex min-h-0 min-w-0 flex-1 gap-1.5">
                  <ActivePositionsCard />
                  <HoldingsCard />
                </div>
              </div>
            </div>
            <div className="flex h-full min-h-[280px] w-full flex-1 gap-1.5">
              <TradesCard />
            </div>
          </CenteredContentLayout>
        </PageLayout>
      </HyperliquidUserDataListener>
    </PortfolioProvider>
  );
}
